
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ReporterService } from '@/services/index'

@Component({
    components: {
    }
})
export default class extends Vue {
    @Prop({ required: true }) private reporter!: any 

    private name: string = ''
    private reporters = []
    private selectedReporters = []
    private mergeLogs = []
    private timer: any = null
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading = true

    private mounted() {
        this.getReporters()
        this.getMergeLogs()
    }

    private async getReporters() {
        const params = { name: this.reporter.name, page_index: this.pageIndex, page_size: this.pageSize }
        const result = await ReporterService.getReportersByName(params)
        if (result.status === 200) {
            this.reporters = result.data.reporters
            this.pageTotal = result.data.page_total
        }
        this.loading = false
    }

    private async getMergeLogs() {
        const params = { reporter_id: this.reporter.id }
        const result = await ReporterService.getMergeLogs(params)
        if (result.status === 200) {
            this.mergeLogs = result.data.logs
        }
    }

    private isValid() {
        if (this.selectedReporters.length === 0) {
            this.$message({ type: 'error', message: '请选择记者' })
            return false
        }
        return true
    }

    private onSelectionChange(val: any) {
        this.selectedReporters = val
    }

    private onMerge() {
        if (!this.isValid()) return
        const msg = '是否确定将这' + this.selectedReporters.length + '个记者合并？此操作需要特别谨慎' 
        this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.loading = true
            const reporterIds = this.selectedReporters.map((reporter: any) => {
                return reporter.id
            })
            const params = { reporter_ids: reporterIds }
            const result = await ReporterService.merge(params)
            if (result.status === 200) {
                this.$message({ 
                    type: 'success', 
                    message: '记者数据合并成功，5s后进入合并后的记者页面',
                    duration: 5000
                })
                if (this.timer) clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                    this.pageIndex = 1
                    this.getReporters()
                }, 5000)
            } else {
                this.$message({ type: 'error', message: result.message })
            }
            this.loading = false
        }).catch(() => {})
    }

    private onGoNewsList(data: any) {
        window.open('/reporter/' + data.id + '?tab=news')
    }

    private onGoOrigin(data: any) {
        window.open('/news/' + data.source_news.id)
    }

    private onCurrentChange(page: number) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getReporters()
        $backtop.scrollToTop()
    }
}
